import { render, staticRenderFns } from "./DeleteRateModel.vue?vue&type=template&id=95d86b4c&"
import script from "./DeleteRateModel.vue?vue&type=script&lang=js&"
export * from "./DeleteRateModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports